module.exports = __webpack_public_path__ + "img/83.f942667.png";